// extracted by mini-css-extract-plugin
module.exports = {"body":"style__body__zXFz5","content":"style__content__8eaUz","footer":"style__footer__-Vc09"};